module.exports = __webpack_public_path__ + "media/images/flags/vc-d134e574d52ebb8c0570a742af44a141.svg";